import type { PopulatedMenu } from '../types/menu';

export type SectionTab = {
  id: string;
  label: string;
};

export type MenuOption = {
  id: string;
  value: string;
};

export const buildSectionTabs = (
  menus: PopulatedMenu[],
  selectedMenuId?: string,
): SectionTab[] => {
  const targetMenus =
    selectedMenuId && menus.length > 1
      ? menus.filter((menu) => menu.id === selectedMenuId)
      : menus;

  return targetMenus.flatMap((menu) =>
    (menu.sections ?? []).map((section) => ({
      id: section.id,
      label: section.name ?? '',
    })),
  );
};

export const buildMenuOptions = (menus: PopulatedMenu[]): MenuOption[] =>
  menus.map((menu) => ({
    id: menu.id,
    value: menu.name ?? '',
  }));
